import { Nullable } from '../../../../../../@types/Nullable';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../../data';
import { api } from '../../../../../../lib';
import { RulesPageRuleType } from '../../../../../../reducers/ipa/strategy/rulesPage/filters/type';
import { MechanismType, RulePriceType } from '../../RegrasDePreco/lib';

export type ListRulesBody = {
  name?: string;
  page?: number;
  size?: number;
  type: RulesPageRuleType;
};

type Mechanism = Nullable<{
  factor: number;
  mechanismType: MechanismType;
}>;

type Recurrence = Nullable<{
  recurrenceType: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  startingDate: string;
  expirationDate: string;
}>;

export type RuleSegment = Record<'level' | 'value' | 'description', string | null>;

export type RuleDataItem = Nullable<{
  name: string;
  ruleId: string;
  segments: RuleSegment[];
  storeIds: string[];
  clusters: Record<'id' | 'label', string>[];
  mechanism: Mechanism;
  recurrence: Recurrence;
  rulePriceType: RulePriceType;

  sensibilityType: string[];
  infoPriceSensibility: string[];
  infoPriceAbcClass: string[];
  infoPriceGlobalAbcClass: string[];
  abcClass: string[];
}>;

export type ListRulesReturn = {
  content: RuleDataItem[];
  totalElements: number;
};

export const listRules = async (body?: ListRulesBody) => {
  const ERROR_MESSAGE = 'Erro ao buscar regras';
  try {
    const response = await api.post<ListRulesReturn>('/rules/search/page', body, {
      expectToken: true,
    });

    return response.data;
  } catch {
    const { message } = new Exception(ERROR_MESSAGE);
    throw AlertWithTimestamp({ message });
  }
};
